export default {
    created() {
        // 分享
        EVENTHUB.on('share', callback => {
            if (this.MapView) {
                const centerZoom = this.MapView.centerZoom
                callback('map', centerZoom)
            }
        })
    },
    methods: {
        // 提供方法，主动调用
        bindShareData() {
            // 绑定分享
            this.$ShareData.bind('map', centerZoom => {
                if (this.MapView) {
                    this.MapView.centerZoom = centerZoom
                }
            })
        }
    }
}
